import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SystemOverview } from './components/SystemOverview';
import { Bonuses } from './components/Bonuses';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingTable } from './components/PricingTable';
import { Accelerator } from './components/Accelerator';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostSection } from './components/CostSection';
import { Footer } from './components/Footer';
export function App() {
  const testimonials1 = [{
    initials: 'VL',
    name: 'Valentina L.',
    location: 'Córdoba',
    text: 'Nunca había calculado mis costos reales. Subí los precios un 40% con fundamento y no perdí ninguna clienta que importara.'
  }, {
    initials: 'MS',
    name: 'Micaela S.',
    location: 'Rosario',
    text: 'Con los scripts del Bono 2 cerré 4 turnos el mismo día que los cargué en WhatsApp Business.'
  }, {
    initials: 'CG',
    name: 'Carolina G.',
    location: 'Buenos Aires',
    text: 'Al mes de aplicar el sistema tenía la agenda llena, política de seña activa y mis primeras reseñas de Google.'
  }];
  const testimonials2 = [{
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza',
    text: 'El Tomo 3 me abrió los ojos. Estaba cobrando $4.000 menos por servicio de lo que necesitaba. Subí los precios, apliqué el guión del Bono 2 y no perdí ninguna clienta seria.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    text: 'El sistema de fidelización del Tomo 5 fue un antes y un después. El 75% de mis clientas ahora vuelve sola. No necesito correr atrás de nadie.'
  }, {
    initials: 'SA',
    name: 'Sofía A.',
    location: 'Neuquén',
    text: 'Solté 3 clientas tóxicas con el Bono 6 y en 3 semanas esos lugares los ocuparon clientas que pagan sin regatear. Trabajo menos horas y gano más.'
  }, {
    initials: 'PA',
    name: 'Paula A.',
    location: 'Mar del Plata',
    text: 'En 30 días con el Acelerador logré más que en 2 años improvisando. La agenda llena, los precios actualizados y mis primeras 12 reseñas en Google.'
  }];
  return <div className="min-h-screen bg-dark text-white selection:bg-brand selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials testimonials={testimonials1} data-id="element-3" />
      <PainPoints data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <Bonuses data-id="element-6" />

      <section className="py-12 px-4 text-center bg-dark-card border-y border-dark-border" data-id="element-7">
        <div className="max-w-3xl mx-auto" data-id="element-8">
          <div className="text-brand font-bold mb-4 tracking-widest text-sm" data-id="element-9">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>
          <CountdownTimer data-id="element-10" />
          <div className="mt-6 text-red-400 font-medium" data-id="element-11">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </div>
          <div className="mt-4 flex items-center justify-center space-x-2" data-id="element-12">
            <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-13" />
            <span className="text-sm text-gray-400" data-id="element-14">
              Quedan pocos cupos al precio de lanzamiento
            </span>
          </div>
          <div className="w-full max-w-md mx-auto h-2 bg-dark rounded-full mt-4 overflow-hidden" data-id="element-15">
            <div className="h-full bg-brand w-[68%]" data-id="element-16" />
          </div>
          <div className="text-xs text-gray-500 mt-2" data-id="element-17">
            68% de los cupos ya tomados
          </div>
        </div>
      </section>

      <PricingTable data-id="element-18" />
      <Accelerator data-id="element-19" />

      <div className="py-12" data-id="element-20">
        <div className="text-center mb-8" data-id="element-21">
          <h2 className="text-3xl font-black" data-id="element-22">
            ❤️ MÁS MANICURISTAS QUE YA LO TIENEN
          </h2>
        </div>
        <Testimonials testimonials={testimonials2} data-id="element-23" />
      </div>

      <Guarantee data-id="element-24" />
      <FAQ data-id="element-25" />
      <CostSection data-id="element-26" />

      <section className="py-20 px-4 bg-dark-card border-t border-dark-border" data-id="element-27">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-28">
          <div className="text-brand font-bold mb-4 tracking-widest text-sm" data-id="element-29">
            ⏰ EL PRECIO CIERRA EN:
          </div>
          <CountdownTimer data-id="element-30" />
        </div>
        <PricingTable data-id="element-31" />
        <div className="max-w-3xl mx-auto mt-12 flex flex-wrap justify-center gap-6 text-sm text-gray-500" data-id="element-32">
          <div className="flex items-center space-x-2" data-id="element-33">
            <span data-id="element-34">🔒</span> <span data-id="element-35">Pago 100% seguro</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-36">
            <span data-id="element-37">⚡</span> <span data-id="element-38">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-39">
            <span data-id="element-40">🛡️</span> <span data-id="element-41">Garantía 7 días</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-42">
            <span data-id="element-43">💳</span> <span data-id="element-44">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </section>

      <Footer data-id="element-45" />
    </div>;
}